/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Slide } from '@coursera/cds-core';

import { zIndex } from 'bundles/authoring/style-constants/layout';
import MathEditorDialog from 'bundles/cml/editor/components/elements/math/MathEditorDialog';
import type { Props } from 'bundles/cml/editor/components/elements/math/MathEditorDialog';
import { hoverMenu } from 'bundles/cml/shared/styles';

const styles = {
  root: css`
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: ${zIndex.modal};
  `,
  dialog: css`
    ${hoverMenu()}
  `,
};

const MathEditorSmall = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  return (
    <Slide direction="up" in>
      <div className="rc-CMLEditorMenu" css={styles.root}>
        <MathEditorDialog ref={ref} {...props} css={styles.dialog} />
      </div>
    </Slide>
  );
});

export default MathEditorSmall;
